




































import { Component, Prop } from 'vue-property-decorator';
import { Checkbox } from '@/components/forms';
import { WidgetGeneric } from './WidgetGeneric';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';
import { MarkerTemplateParams } from '@/models/widget-config.model';

@Component({
  components: { Checkbox }
})
export default class WidgetQualityOfLifeType extends WidgetGeneric {
  @Prop({ required: true, default: [] }) readonly checkboxes!: Record<string, any>[];
  @Prop({ required: true }) readonly closeOpenSubCategories!: () => void;

  created(): void {
    this._mapStore = getModule(MapStore, this.$store);
    this._points = new Map();
    this._widgetType = 'QUALITY_OF_LIFE';
    this._config = this._createConfig();
    this._mapStore.map.on('click', this._removePopups);
  }

  beforeDestroy(): void {
    this.checkboxes.forEach((checkbox: any) => {
      checkbox.selected = false;
      if (checkbox.open) checkbox.open = false;
      if (checkbox.subCat) {
        checkbox.subCat.forEach((el: any) => {
          el.selected = false;
        });
      }
    });
    this._mapStore.setPointsOfInterestModal(false);
    this._beforeDestroy();
  }

  change({ type, value }: { type: string; value: boolean }) {
    if (this._config[type].tableNames) {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) {
          this._points.get(table).visibility = value;
        }
      });
    } else {
      if (this._points.has(type)) {
        this._points.get(type)!.visibility = value;
      }
    }
    if (type === 'points-of-interest') {
      if (!value) this._removePopups();
      this._mapStore.setPointsOfInterestModal(value);
    }

    if (this._config[type].tableNames) {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) this._addToMap();
        else {
          this._getPoints(table).then(() => this._addToMap());
        }
      });
    } else {
      if (this._points.has(type)) this._addToMap();
      else this._getPoints(type).then(() => this._addToMap());
    }
  }

  private _createConfig() {
    const config: any = {};
    this.checkboxes.forEach((checkbox: Record<string, any>) => {
      config[checkbox.type] = { marker: WidgetQualityOfLifeType._markerTemplate, tableName: checkbox.type };
      if (checkbox.subCat) {
        config[checkbox.type].tableNames = checkbox.subCat.map((el: any) => {
          config[el.type] = { marker: WidgetQualityOfLifeType._markerTemplate };
          return el.type;
        });
      }
    });
    return config;
  }

  private static _markerTemplate({ type }: MarkerTemplateParams): HTMLDivElement {
    const markerElement = document.createElement('div');
    markerElement.classList.add(
      'marker-quality-of-life',
      `marker-quality-of-life--${type.toLowerCase()}`,
      'background-color'
    );
    return markerElement;
  }

  destroyed(): void {
    this._mapStore.removeLayer({ type: this._widgetType });
    this._mapStore.removeSource({ type: this._widgetType });
    this._mapStore.removeLayer({ type: 'QUALITY_OF_LIFE_MULTIPOLYGON' });
    this._mapStore.removeSource({ type: 'QUALITY_OF_LIFE_MULTIPOLYGON' });
    this._mapStore.map.off('click', this._removePopups);
    this._removePopups();
  }
}
